import React, { useEffect, useState } from 'react'
import { Box, Flex, Stack, Text, useDisclosure } from '@chakra-ui/react'

import { Option } from 'types'
import AutoCompleteItem from './components/AutoCompleteItem'
import AutoCompleteSearch from './components/AutoCompleteSearch'
import { Close, SimpleDownArrow } from 'components/icons'

type Props = {
  defaultValue?: string
  options: Array<Option>
  onChange: (value: string | number) => void
}

const AutoComplete = ({ defaultValue, options, onChange }: Props) => {
  const [input, setInput] = useState<string>('')
  const [search, setSearch] = useState<string>('')
  const [value, setValue] = useState<string>('')
  const [filteredOptions, setFilteredOptions] = useState<Option[]>(options)

  const { isOpen, onClose, onOpen } = useDisclosure()

  const handleOnSelect = ({ label, value }: Option) => {
    setInput(label)
    setValue(value)
    onClose()
  }

  const handleFilterOptions = () => {
    const updatedOptions: Option[] = options.filter((option) => {
      return option.label.toLowerCase().includes(search.toLowerCase())
    }, [])
    setFilteredOptions(updatedOptions)
  }

  useEffect(() => {
    if (search !== '') {
      handleFilterOptions()
    } else {
      setFilteredOptions(options)
    }
  }, [search])

  useEffect(() => {
    if (value !== '') onChange(value)
  }, [value])

  useEffect(() => {
    if (defaultValue) {
      options.forEach((option) => {
        if (option.value === defaultValue) {
          setInput(option.label)
          setValue(option.value)
        }
      })
    }
  }, [defaultValue])

  // useEffect(() => {
  //   console.log('Alo')
  //   document.body.addEventListener('click', function (event) {
  //     console.log('Entro')

  //     if (document.getElementById('clickbox')?.contains(event.target as Node)) {
  //       console.log('Entro A')
  //       // Clicked in box
  //     } else {
  //       console.log('Entro B')
  //       onClose()
  //     }
  //   })
  // }, [isOpen])

  return (
    <Stack id="clickbox">
      <Flex
        p={1}
        px={2}
        align="center"
        justify="space-between"
        width="250px"
        minWidth="100%"
        className="accessible"
        bg="bgContent"
        borderWidth="1px"
        borderColor="borderColor"
        _hover={{ bg: 'lightPrimary', borderColor: 'primary' }}
        onClick={onOpen}
      >
        {input !== '' ? <Text>{input}</Text> : <Text variant="secondary">Selecione um valor</Text>}

        {isOpen ? (
          <Close
            boxSize={6}
            className="clicable"
            color="danger"
            onClick={(event) => {
              event.stopPropagation()
              onClose()
            }}
            _hover={{ color: 'dangerHover' }}
          />
        ) : (
          <SimpleDownArrow boxSize={6} />
        )}
      </Flex>

      {isOpen && (
        <Box rounded="md" bg="bgContent" borderWidth="1px" borderColor="borderColor">
          <Flex align="center" borderBottomWidth="1px" borderColor="borderColor" pe={1}>
            <AutoCompleteSearch search={search} setSearch={setSearch} />
          </Flex>
          {filteredOptions.length === 0 ? (
            <Box p={4}>
              <Text textAlign="center">Nenhum opção encontrada</Text>
            </Box>
          ) : (
            <Box rounded="md" p={1} maxHeight="200px" overflowY="auto" tabIndex={0}>
              {filteredOptions.map((option, index) => {
                const isSelected = option.value === value
                return (
                  <AutoCompleteItem
                    key={option.label}
                    option={option}
                    options={options}
                    isSelected={isSelected}
                    handleOnSelect={handleOnSelect}
                    index={index}
                  />
                )
              })}
            </Box>
          )}
        </Box>
      )}
    </Stack>
  )
}

export default AutoComplete
